import http from "./http";

export const fetchProductData = () => http.get("/investments/products");
export const fetchSingleProductData = (id) => http.get(`/investments/products/view/${id}`)
export const fetchProductType = () => http.get("/investments/types/");

export const createProduct = (credentials) => {
    return http.post("/investments/products/add", credentials)
}

export const updateProduct = (id, payload) => {
  return http.patch(`investments/products/update/${id}`, payload) 
}

export const addProductType = (credentials) => {
    return http.post("/investments/types/add", credentials)
}

export const updateProductType = (id, payload) => {
    return http.patch(`investments/types/update/${id}`, payload) 
}

export const activateProduct = (id) => {
    return http.patch(`/investments/products/activate/${id}`)
}

export const deactivateProduct = (id) => {
    return http.patch(`/investments/products/deactivate/${id}`)
}

export const endProductLifeCycle = (id) => {
    return http.patch(`/investments/products/end-lifecycle/${id}`)
}

export const processPayment = (id) => {
    return http.post(`/investments/products/process-payout/${id}`)
}